module.exports = {
      id: "bookmark-outline-usage",
      viewBox: "0 0 24 36",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#bookmark-outline",
      toString: function () {
        return this.url;
      }
    }